package scenes

import com.soywiz.korge.input.*
import com.soywiz.korge.scene.*
import com.soywiz.korge.ui.*
import com.soywiz.korge.view.*
import com.soywiz.korim.color.*
import com.soywiz.korim.text.*
import com.soywiz.korma.geom.*
import com.soywiz.korma.geom.vector.*
import game.*
import utils.*

class TalentsScene : Scene() {

    private val talentState = TalentState(10)

    override suspend fun SContainer.sceneInit() {

    }

    override suspend fun SContainer.sceneMain() {
        uiText("Таланты", width = GameDimensions.V_WIDTH.toDouble()) {
            textAlignment = TextAlignment.CENTER
            textSize = 48.0
        }.position(0, 10)

        talentState.talentsCountText = uiText(TalentState.talentsCountString(talentState.talentsCount))
            .position(10.0, GameDimensions.V_HEIGHT / 5.0)

        backButton()

        val resistanceButton = resistanceBranchButton()
        val trapsButton = trapsBranchButton(resistanceButton)
        val magicButton = magicBranchButton(resistanceButton)

        val trapsBranch = trapsBranch()
        val resistanceBranch = resistanceBranch()
        val magicBranch = magicBranch()

        val tabsView = TabsView(
            buttons = listOf(trapsButton, resistanceButton, magicButton),
            pages = listOf(trapsBranch, resistanceBranch, magicBranch)
        )
    }

    class TabsView(
        private val buttons: List<UIButton>,
        private val pages: List<Container>
    ) {

        var selectedIndex = 0
            private set

        init {
            pages.forEach {
                it.visible = false
            }

            buttons.forEachIndexed { i, button ->
                button.forcePressed = false
                button.apply {
                    onClick {
                        buttons[selectedIndex].forcePressed = false
                        pages[selectedIndex].visible = false

                        selectedIndex = i
                        forcePressed = true
                        pages[selectedIndex].visible = true
                    }
                }
            }

            buttons[0].forcePressed = true
            pages[0].visible = true
        }
    }

    private fun Container.trapsBranchButton(resistanceButton: Container): UIButton {
        val width = GameDimensions.V_WIDTH / 6.0
        val height = 40.0

        // середина между устойчивостью и правым краем
        val startX = resistanceButton.x
        val posX = startX / 2.0 - width / 2.0
        val posY = GameDimensions.V_HEIGHT / 3.0

        return uiButton(
            label = "Ловушки",
            width = width,
            height = height
        ).position(posX, posY)
    }

    private fun Container.trapsBranch(): Container {
        return fixedSizeContainer(
            width = GameDimensions.V_WIDTH.toDouble(),
            height = GameDimensions.V_HEIGHT / 2.0
        ) {
            position(0.0, GameDimensions.V_HEIGHT / 2.0)

            val rectHeight = GameDimensions.V_HEIGHT / 8.0
            val rectWidth = GameDimensions.V_HEIGHT / 8.0

            val containerCenterX = width / 2.0
            val containerCenterY = height / 2.0

            val rectCenterPostY = containerCenterY - rectHeight / 2.0
            val margin = rectWidth

            val rectCount = 4

            val startX = margin
            val endX = width - margin - rectWidth
            val stepX = (endX - startX) / (rectCount - 1).toDouble()

            val trapTalent = solidRect(
                width = rectWidth,
                height = rectHeight,
                color = Colors.DARKGREY
            ).position(startX, rectCenterPostY).apply {
                text("TRAP")
                    .position(x, y)
                onClick {
                    talentState.selectTalent(Talents.TRAP)
                }
            }

            val fakeTrapTalent = solidRect(
                width = rectWidth,
                height = rectHeight,
                color = Colors.DARKGREY
            ).position(startX + 1 * stepX, rectCenterPostY + rectHeight).apply {
                text("TRAP_STEALT")
                    .position(x, y)
                onClick {
                    talentState.selectTalent(Talents.TRAP_STEALTH)
                }
            }

            val trapStealthTalent = solidRect(
                width = rectWidth,
                height = rectHeight,
                color = Colors.DARKGREY
            ).position(startX + 1 * stepX, rectCenterPostY - rectHeight).apply {
                text("FAKE_TRAP")
                    .position(x, y)
                onClick {
                    talentState.selectTalent(Talents.FAKE_TRAP)
                }
            }

            val moreTrapsTalent = solidRect(
                width = rectWidth,
                height = rectHeight,
                color = Colors.DARKGREY
            ).position(startX + 2 * stepX, rectCenterPostY).apply {
                onClick {
                    talentState.selectTalent(Talents.MORE_TRAPS)
                }
            }

            val impulseTrapTalent = solidRect(
                width = rectWidth,
                height = rectHeight,
                color = Colors.DARKGREY
            ).position(startX + 3 * stepX, rectCenterPostY).apply {
                onClick {
                    talentState.selectTalent(Talents.TRAP_IMPULSE_EXPLOSION)
                }
            }

            connectTalents(trapTalent, fakeTrapTalent)
            connectTalents(trapTalent, trapStealthTalent)
            connectTalents(fakeTrapTalent, moreTrapsTalent)
            connectTalents(trapStealthTalent, moreTrapsTalent)
            connectTalents(moreTrapsTalent, impulseTrapTalent)
        }
    }

    private fun Container.resistanceBranchButton(): UIButton {
        val width = GameDimensions.V_WIDTH / 6.0
        val height = 40.0

        val posX = GameDimensions.V_WIDTH / 2.0 - width / 2.0
        val posY = GameDimensions.V_HEIGHT / 3.0

        return uiButton(
            label = "Выживание",
            width = width,
            height = height
        ).position(posX, posY).apply {
            forcePressed = true
        }
    }

    private fun Container.resistanceBranch(): Container {
        return fixedSizeContainer(
            width = GameDimensions.V_WIDTH.toDouble(),
            height = GameDimensions.V_HEIGHT / 2.0
        ) {
            position(0.0, GameDimensions.V_HEIGHT / 2.0)

            val rectHeight = GameDimensions.V_HEIGHT / 8.0
            val rectWidth = GameDimensions.V_HEIGHT / 8.0

            val containerCenterX = width / 2.0
            val containerCenterY = height / 2.0

            val rectCenterPostY = containerCenterY - rectHeight / 2.0
            val margin = rectWidth

            val rectCount = 4

            val startX = margin
            val endX = width - margin - rectWidth
            val stepX = (endX - startX) / (rectCount - 1).toDouble()

            val trapTalent = solidRect(
                width = rectWidth,
                height = rectHeight,
                color = Colors.DARKGREY
            ).position(startX, rectCenterPostY)

            val fakeTrapTalent = solidRect(
                width = rectWidth,
                height = rectHeight,
                color = Colors.DARKGREY
            ).position(startX + 1 * stepX, rectCenterPostY + rectHeight)

            val trapStealthTalent = solidRect(
                width = rectWidth,
                height = rectHeight,
                color = Colors.DARKGREY
            ).position(startX + 1 * stepX, rectCenterPostY - rectHeight)

            val moreTrapsTalent = solidRect(
                width = rectWidth,
                height = rectHeight,
                color = Colors.DARKGREY
            ).position(startX + 2 * stepX, rectCenterPostY)

            val impulseTrapTalent = solidRect(
                width = rectWidth,
                height = rectHeight,
                color = Colors.DARKGREY
            ).position(startX + 3 * stepX, rectCenterPostY)

            connectTalents(trapTalent, fakeTrapTalent)
            connectTalents(trapTalent, trapStealthTalent)
            connectTalents(fakeTrapTalent, moreTrapsTalent)
            connectTalents(trapStealthTalent, moreTrapsTalent)
            connectTalents(moreTrapsTalent, impulseTrapTalent)
        }
    }

    private fun Container.magicBranchButton(resistanceButton: Container): UIButton {
        val width = GameDimensions.V_WIDTH / 6.0
        val height = 40.0

        // середина между устойчивостью и правым краем
        val startX = resistanceButton.x + resistanceButton.width
        val posX = startX + (GameDimensions.V_WIDTH - startX) / 2.0 - width / 2.0
        val posY = GameDimensions.V_HEIGHT / 3.0

        return uiButton(
            label = "Магия",
            width = width,
            height = height
        ).position(posX, posY)
    }

    private fun Container.magicBranch(): Container {
        return fixedSizeContainer(
            width = GameDimensions.V_WIDTH.toDouble(),
            height = GameDimensions.V_HEIGHT / 2.0
        ) {
            position(0.0, GameDimensions.V_HEIGHT / 2.0)

            val rectHeight = GameDimensions.V_HEIGHT / 8.0
            val rectWidth = GameDimensions.V_HEIGHT / 8.0

            val containerCenterX = width / 2.0
            val containerCenterY = height / 2.0

            val rectCenterPostY = containerCenterY - rectHeight / 2.0
            val margin = rectWidth

            val rectCount = 5

            val startX = margin
            val endX = width - margin - rectWidth
            val stepX = (endX - startX) / (rectCount - 1).toDouble()

            val talents = (0 until rectCount).map { i ->
                solidRect(
                    width = rectWidth,
                    height = rectHeight,
                    color = Colors.DARKGREY
                ).position(startX + i * stepX, rectCenterPostY)
            }

            for (i in 0 until rectCount - 1) {
                connectTalents(talents[i], talents[i + 1])
            }
        }
    }

    private fun Container.connectTalents(left: View, right: View) {

        val lineWeight = 1.5

        val firstPoint = Point(
            x = left.x + left.width,
            y = left.y + left.height / 2.0
        )

        val lastPoint = Point(
            x = right.x,
            y = right.y + right.height / 2.0
        )

        if (left.y != right.y) {
            val secondPoint = Point(
                x = firstPoint.x + (lastPoint.x - firstPoint.x) / 2.0,
                y = firstPoint.y
            )
            val thirdPoint = Point(
                x = firstPoint.x + (lastPoint.x - firstPoint.x) / 2.0,
                y = lastPoint.y
            )

            graphics {
                fill(Colors.LIGHTGREY) {
                    rect(
                        x = firstPoint.x,
                        y = firstPoint.y - lineWeight / 2.0,
                        width = secondPoint.x - firstPoint.x,
                        height = lineWeight
                    )
                    if (left.y < right.y) {
                        rect(
                            x = thirdPoint.x - lineWeight,
                            y = thirdPoint.y - lineWeight / 2.0,
                            width = lineWeight,
                            height = secondPoint.y - thirdPoint.y
                        )
                    } else {
                        rect(
                            x = secondPoint.x - lineWeight,
                            y = secondPoint.y - lineWeight / 2.0,
                            width = lineWeight,
                            height = thirdPoint.y - secondPoint.y
                        )
                    }
                    rect(
                        x = thirdPoint.x,
                        y = thirdPoint.y - lineWeight / 2.0,
                        width = lastPoint.x - thirdPoint.x,
                        height = lineWeight
                    )
                }
            }
        } else {
            graphics {
                fill(Colors.LIGHTGREY) {
                    rect(firstPoint.x, firstPoint.y, lastPoint.x - firstPoint.x, lineWeight)
                }
            }
        }
    }

    private fun Container.backButton(): UIButton {
        return uiButton(
            label = "<-",
            width = 50.0,
            height = 20.0
        ).position(10, 10).apply {
            onClick {
                sceneContainer.changeTo<LobbyScene>()
            }
        }
    }
}

class TalentState(
    talentsCount: Int
) {

    var talentsCount = talentsCount
        private set

    lateinit var talentsCountText: UIText

    // talent id to count
    private val selectedTalents: MutableMap<Talents, Int> = mutableMapOf()

    fun canSelect(talent: Talents): Boolean {
        return talentsCount > 0 &&
            talent.talentSelectionRule.invoke(selectedTalents)
    }

    fun selectTalent(talent: Talents) {
        if (!canSelect(talent)) {
            return
        }

        talentsCount--
        selectedTalents[talent] = (selectedTalents[talent] ?: 0) + 1
        talentsCountText.text = talentsCountString(talentsCount)
    }

    companion object {
        fun talentsCountString(count: Int) = "Осталось $count"
    }
}

data class TalentBranch(
    val id: Long,
    val name: String,
    val talents: List<TalentSlot>
)

data class TalentSlot(
    val prev: List<Talent>,
    val next: List<Talent>
)

data class Talent(
    val id: Long,
    val name: String,
    val description: String,
    val count: Int
)
